import React from 'react';
import VideoCover from 'react-video-cover';
import { Button } from 'reactstrap';
import spbrand from '../assets/images/spbrand.svg';

export default class VideoCoverFullScreen extends React.Component {

  state = {
    display: 'none',
    displayButton: false
  }

  _play(){
    if (this.videoRef && this.videoRef.paused) {
      this.videoRef.play();
      this.setState({ displayButton: false });
    }
  }

  _renderButton(){
    if (this.state.displayButton) {
      return <div className="playVideoInit">
      <img src={spbrand} width="100" alt="logotipo" />
        <p>&nbsp;</p>
        <Button onClick={() => this._play()}> EMPEZAR </Button>
      </div>
    }
  }

  render() {
    if (!this.props.src) return ('');

    const videoOptions = {
      src: this.props.src,
      ref: videoRef => {
        this.videoRef = videoRef;
        if (this.videoRef !== null && this.videoRef.paused && !this.state.displayButton) {
          try {
            this.videoRef.play().catch(e => {
              this.setState({ displayButton: true });
            });
          } catch (error) {
            this.setState({ displayButton: true });
          }
        }
      },
      onEnded: e => this.props.finish(),
      // autoPlay: true,
      onPlaying: e => {
        console.log('onPlaying');
        this.setState({ display: 'block' });
      },
      onClick: () => {
        console.log('onClick');
        if (this.videoRef && this.videoRef.pausado) {
          this.videoRef.play();
        }
      },
      onError: e => this.props.finish()
    };

    const style = {
      width: '100vh',
      height: '100vh',
      position: 'fixed',
      top: 0,
      left: 0,
      zIndex: -1,
      display: this.state.display
    };

		return (
      <div>
        {this._renderButton()}
        <div style={style} >
          <VideoCover videoOptions={videoOptions} />
        </div>
      </div>
		);
  }
}


// WEBPACK FOOTER //
// ./src/components/VideoCoverFullScreen.js